import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getNeededLanguage } from '@/utils/lang';
import messageEn from '@/assets/locales/en-US';
import messageKo from '@/assets/locales/ko-KR';
import messageCn from '@/assets/locales/zh-CN';
import messageJa from '@/assets/locales/ja-JP';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  fallbackLocale: getNeededLanguage(),
  locale: getNeededLanguage(),
  messages: {
    en: messageEn,
    ko: messageKo,
    zh: messageCn,
    ja: messageJa,
  },
});
